import { REGISTER_PS, REGISTER_CPS } from './const.js'

export const register = {
    uppercase: '大文字',
    lowercase: '小文字',
    symbol: '特別なシンボル',
    digital: 'デジタル',
    '8bit': '8ビット',
    repeatPwdError: '入力された2つのパスワードに一貫性がありません',
    show: '表示',
    hide: '非表示',
    pageTitle: 'Intelligent Business Analytics',
    register: '初期設定',
    pwd: REGISTER_PS,
    cPwd: REGISTER_CPS,
    phoneNumber: '国際電話番号',
    phoneNumberTip: '（入力例：09012345678 の場合、+819012345678 と入力）',
    submit: '設定する',
    noEmailError: '必要なパラメータがありません (Email, orgId または registrationToken)',
    registedError: 'アカウントが登録されました、直接的にログインしてください。',
    phoneNumberError: '電話番号形式が正しくありません。'
}
